export default [
  {
    path: '/b2bhub/configuracao/jobs-erp',
    name: 'jobs-erp',
    component: () => import('@/views/app/configuracao/integracaoErp/jobsErp.vue'),
    meta: {
      pageTitle: 'Jobs de Integração',
      action: 'manage',
      resource: 'IntegracaoErp',
    },
  },
  {
    path: '/b2bhub/configuracao/dashboard-integracao',
    name: 'dashboard-integracao',
    component: () => import('@/views/app/configuracao/integracaoErp/dashboardIntegracao.vue'),
    meta: {
      pageTitle: 'Dashboard Integrações',
      action: 'manage',
      resource: 'IntegracaoErp',
    },
  },
  {
    path: '/b2bhub/configuracao/jobs-erp/:id/execucoes',
    name: 'jobs-erp-execucoes',
    component: () => import('@/views/app/configuracao/integracaoErp/historicoJob.vue'),
    meta: {
      pageTitle: 'Histórico de Execuções',
      navActiveLink: 'jobs-erp',
      action: 'manage',
      resource: 'IntegracaoErp',
    },
  },
  {
    path: '/b2bhub/configuracao/jobs-erp/:id/mapeamento',
    name: 'jobs-erp-mapeamento',
    component: () => import('@/views/app/configuracao/integracaoErp/MapeamentoJob.vue'),
    meta: {
      pageTitle: 'Mapeamento de Dados',
      navActiveLink: 'jobs-erp',
      action: 'manage',
      resource: 'IntegracaoErp',
    },
  },
];
